import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { User } from '../models/user.model';
import { Globals } from './../helpers';
import { HttpInterceptor } from './http-error.interceptor';

@Injectable()
export class UserService {
  private userServiceUrl: string;
  private userAccPasswordUrl: string;

  constructor(private http: HttpInterceptor, private globals: Globals) {
    this.userServiceUrl = globals.url + 'users';
    this.userAccPasswordUrl = globals.url + 'account/password';
  }

  public verify() {
    return this.http
      .get(this.globals.url + 'account/session')
      .map((response: Response) => response.json());
  }

  public forgotPassword(email: string) {
    // return this.http.post('/api/forgot-password', JSON.stringify({ email })).map((response: Response) => response.json());
    return null;
  }

  public getAll() {
    return this.http
      .get(this.userServiceUrl + '?limit=999')
      .map((response: Response) => response.json());
  }

  public getAllByType(type: number) {
    return this.http
      .get(this.userServiceUrl + '?type=' + type + '&limit=999')
      .map((response: Response) => response.json());
  }

  public getById(id: string) {
    return this.http
      .get(this.userServiceUrl + '/' + id)
      .map((response: Response) => response.json());
  }

  public create(user: User) {
    return this.http
      .post(this.userServiceUrl, user)
      .map((response: Response) => response.json());
  }

  public update(userId: string, user: User) {
    return this.http
      .put(this.userServiceUrl + '/' + userId, user)
      .map((response: Response) => response.json());
  }

  public delete(userId: string) {
    return this.http
      .delete(this.userServiceUrl + '/' + userId)
      .map((response: Response) => response.json());
  }

  public updateUserAcc(userId: string, user: User) {
    return this.http
      .put(this.userAccPasswordUrl, user)
      .map((response: Response) => response.json());
  }

  public getUserDevices(id: string, page?, limit?, filters?) {
    let url = this.userServiceUrl + '/' + id + '/devices';
    if (typeof page == 'number' && typeof limit == 'number') {
      url = this.prepareUrlFilters(url, { ...filters, page, limit });
    } else {
      url = this.prepareUrlFilters(url, filters);
    }
    return this.http.get(url).map((response: Response) => response.json());
  }

  public getUserContent(id: string) {
    return this.http
      .get(this.userServiceUrl + '/' + id + '/contents')
      .map((response: Response) => response.json());
  }

  public getUserDiskUsage() {
    return this.http
      .get(this.userServiceUrl + '/myUsage')
      .map((response: Response) => response.json());
  }
  public getUsersDiskUsage() {
    return this.http
      .get(this.userServiceUrl + '/usage')
      .map((response: Response) => response.json());
  }

  public getCountries() {
    return this.http
      .get(this.userServiceUrl + '/countries')
      .map((response: Response) => response.json());
  }

  private prepareUrlFilters(url, filters) {
    const params: URLSearchParams = new URLSearchParams();
    if (!filters || !Object.keys(filters).length) { return url; }
    Object.entries(filters).forEach(([key, value]) => {
      params.append(key, value.toString());
    });
    const paramsStr = params.toString();
    if (paramsStr) { url += '?' + paramsStr; }
    return url;
  }
}
